var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pill subtitle-2",style:({
    'color': (_vm.color || '#FFFFFF'),
    'background-color': (_vm.background || '#041E42'),
    'min-width': (_vm.minWidth || '')
  })},[_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }